import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio } from "lucide-react";
import { api } from "@/lib/api";

export const relSync = (iso) => {
  if (!iso) return "—";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  return `${Math.floor(m / 60)}h ago`;
};

export function SyncHealthBadge() {
  const nav = useNavigate();
  const [h, setH] = useState(null);
  const load = () => api.get("/admin/sync/health").then((r) => setH(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);
  if (!h?.configured) return null;
  const live = h.owner_reachable;
  const last = relSync(h.last_push_at || h.last_pull_at);
  return (
    <button data-testid="sync-health-badge" onClick={() => nav("/admin/sync")}
      title={`Owner App ↔ Website sync · last synced ${last}`}
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full font-semibold ${live ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>
      <Radio size={11} className={live ? "text-emerald-600 animate-pulse" : "text-rose-500"} />
      <span className="hidden sm:inline" data-testid="sync-health-label">{live ? "App Sync Live" : "App Sync Off"}</span>
      <span className="hidden md:inline text-[10px] font-medium opacity-80" data-testid="sync-health-last">· {last}</span>
    </button>
  );
}
